import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useSearchParams } from '@uhg-abyss/web/tools/reactRouterTools';
import React, { useEffect } from 'react';

export const DeeplinkContainer = () => {
  const { navigate } = useRouter();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('lineOfBusiness')) {
      navigate('/browse', {
        state: {
          lineOfBusiness: searchParams.get('lineOfBusiness'),
          policyNumber: searchParams.get('policyNumber'),
          reciprocityId: searchParams.get('reciprocityId'),
          planVariationCode: searchParams.get('planVariationCode'),
          coverageTypeCode: searchParams.get('coverageTypeCode'),
          coverageEffStartDate: searchParams.get('coverageEffStartDate'),
          coverageEffEndDate: searchParams.get('coverageEffEndDate'),
        },
      });
    }
  }, []);

  return <></>;
};
